import React, { useState, useRef, useEffect } from 'react'
import { withApi } from 'shared-ui/api/ApiContext'
import ConnexusIcon from 'shared-ui/assets/img/jti-connexus-icon.svg'
import B2XIcon from 'shared-ui/assets/img/b2x-app-icon.svg'
import TapIcon from 'shared-ui/assets/img/jti-tap-icon.svg'
import PldIcon from 'shared-ui/assets/img/pld-icon.svg'

const ICON_MAP = {
  cnx: ConnexusIcon,
  b2x: B2XIcon,
  tap: TapIcon,
  pld: PldIcon,
}

const GripIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <circle cx="5" cy="5" r="1.5" />
    <circle cx="12" cy="5" r="1.5" />
    <circle cx="19" cy="5" r="1.5" />
    <circle cx="5" cy="12" r="1.5" />
    <circle cx="12" cy="12" r="1.5" />
    <circle cx="19" cy="12" r="1.5" />
    <circle cx="5" cy="19" r="1.5" />
    <circle cx="12" cy="19" r="1.5" />
    <circle cx="19" cy="19" r="1.5" />
  </svg>
)

const HeaderSwitchApp = props => {
  const { items = [] } = props

  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  if (!items?.length) return null

  const apps = items.map(item => ({
    ...item,
    Icon: ICON_MAP[item.value?.toLowerCase()] || null,
  }))

  return (
    <div className="relative md:ml-3" ref={wrapperRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-[10px] border border-gray-200 bg-white hover:bg-gray-100"
      >
        <GripIcon />
      </button>

      {open && (
        <div className="absolute left-0 z-[1001] mt-2 w-56 rounded-lg border border-gray-200 bg-white px-3 py-3 shadow-md">
          <div className="flex flex-col gap-1">
            {apps.map(app => {
              const Icon = app.Icon
              return (
                <a
                  key={app.value}
                  href={app.url}
                  className="flex items-center gap-3 rounded-md p-2 no-underline transition-colors hover:bg-gray-100"
                >
                  <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-md">
                    {Icon && <Icon className="h-8 w-8" />}
                  </div>
                  <span className="text-base text-gray-900">{app.label}</span>
                </a>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default withApi(HeaderSwitchApp)
